import { render, staticRenderFns } from "./ModalNewEvol.vue?vue&type=template&id=19963b41&"
import script from "./ModalNewEvol.vue?vue&type=script&lang=js&"
export * from "./ModalNewEvol.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports